import React from 'react'
import { CONSENT_DOCUMENT_PATH } from '../consentDocument'
import { authCardStyles as s } from './AuthCard'

export const CONSENT_LABEL_PREFIX = 'Даю согласие на обработку персональных данных '
export const CONSENT_LINK_LABEL = 'на условиях согласия'

// Одна галочка на регистрацию и экран согласия: текст, ссылка и обязательность
// не должны разойтись между двумя экранами. Снята по умолчанию —
// предотмеченное согласие не считается данным. Ссылка открывается новой
// вкладкой: форма живёт и внутри iframe CRM, где переход по ссылке потерял
// бы форму вместе с введённым.
export default function ConsentCheckbox ({ id = 'personal-data-consent', checked, onChange }) {
  return (
    <label htmlFor={id} style={s.consentRow}>
      <input
        id={id}
        type='checkbox'
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        style={s.consentBox}
      />
      <span>
        {CONSENT_LABEL_PREFIX}
        <a
          href={CONSENT_DOCUMENT_PATH}
          target='_blank'
          rel='noopener noreferrer'
          style={s.consentLink}
        >
          {CONSENT_LINK_LABEL}
        </a>
        {' '}
        <span style={s.required} aria-hidden='true'>*</span>
      </span>
    </label>
  )
}
